<div class="relative w-full">
  <input
    #fileInput
    type="file"
    accept=".pdf,.docx"
    id="{{ control }}"
    [attr.multiple]="multiple ? '' : null"
    (change)="onFileChange($event)"
    class="pointer-events-auto absolute inset-0 z-10 min-h-[146px] w-full cursor-pointer opacity-0" />

  <label
    [for]="control"
    [ngClass]="{ 'border-destructive': displayErrors() }"
    class="pointer-events-none flex min-h-[146px] w-full cursor-pointer flex-col items-center justify-center gap-3.5 rounded-2xl border border-border bg-background p-4 text-center">
    <div class="pointer-events-auto flex w-full justify-center">
      @if (filePreviews[control]?.length) {
        @if (filePreviews[control].length > 1) {
          <div class="flex w-full flex-col gap-3">
            @for (file of filePreviews[control]; track file.file.name) {
              <div class="mb-2 flex w-full items-center justify-between gap-2 border-b border-gray-200 pb-2">
                <div class="flex items-center gap-3">
                  <lucide-icon name="file" size="20" class="text-tertiary-foreground" />
                  <span>{{ file.file.name }}</span>
                </div>
                <button
                  type="button"
                  class="pointer-events-auto z-20 font-bold text-destructive"
                  (click)="$event.stopPropagation(); removeFile(file.file.name)">
                  ✕
                </button>
              </div>
            }
          </div>
        } @else {
          <div class="relative flex flex-col items-center gap-2">
            <button
              type="button"
              class="pointer-events-auto absolute -right-2 -top-2 z-20 text-base leading-none text-destructive"
              (click)="$event.stopPropagation(); removeFile(filePreviews[control][0].file.name)">
              ✕
            </button>
            <lucide-icon name="file" size="60" class="text-tertiary-foreground" />
            <span class="break-all text-sm">{{ filePreviews[control][0].file.name }}</span>
          </div>
        }
      } @else {
        <div class="pointer-events-auto flex flex-col items-center gap-3.5">
          <div class="w-fit rounded-[50%] border border-gray-100 p-[1px]">
            <div
              class="h-[40px] w-[40px] rounded-[50%] border border-background bg-[linear-gradient(180deg,hsl(var(--gradient-base-start))_0%,hsl(var(--gradient-base-end))_100%)]">
              <div class="flex h-full w-full items-center justify-center">
                <img src="assets/media/icons/upload-icon.svg" alt="icon" class="h-[22px] w-[22px] object-contain" />
              </div>
            </div>
          </div>
          <div class="flex flex-col gap-1 text-center">
            <p class="text-base font-medium text-foreground">Drag & drop or choose files to upload</p>
            <div class="flex justify-center gap-1">
              <p class="text-xs text-muted-foreground">Max file size {{ maxSizeMB }}MB</p>
              @if (multiple) {
                <p class="text-xs text-muted-foreground">each, max {{ maxFileNumber }} files total</p>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </label>

  @if (displayErrors()) {
    <div class="mt-1 text-xs text-destructive">
      @if (formControl.hasError('required')) {
        <span>This field is required.</span>
      }
    </div>
  }
</div>
